!function (t) {
  var n = t.util.clone(t.languages.javascript);
  t.languages.jsx = t.languages.extend("markup", n), t.languages.jsx.tag.pattern = /<\/?(?:[\w.:-]+\s*(?:\s+(?:[\w.:-]+(?:=(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s{'">=]+|\{(?:\{(?:\{[^}]*\}|[^{}])*\}|[^{}])+\}))?|\{\.{3}[a-z_$][\w$]*(?:\.[a-z_$][\w$]*)*\}))*\s*\/?)?>/i, t.languages.jsx.tag.inside.tag.pattern = /^<\/?[^\s>\/]*/i, t.languages.jsx.tag.inside["attr-value"].pattern = /=(?!\{)(?:("|')(?:\\[\s\S]|(?!\1)[^\\])*\1|[^\s'">]+)/i, t.languages.insertBefore("inside", "attr-name", {
    spread: {
      pattern: /\{\.{3}[a-z_$][\w$]*(?:\.[a-z_$][\w$]*)*\}/,
      inside: {
        punctuation: /\.{3}|[{}.]/,
        "attr-value": /\w+/
      }
    }
  }, t.languages.jsx.tag), t.languages.insertBefore("inside", "attr-value", {
    script: {
      pattern: /=(\{(?:\{(?:\{[^}]*\}|[^}])*\}|[^}])+\})/i,
      inside: {
        "script-punctuation": {
          pattern: /^=(?={)/,
          alias: "punctuation"
        },
        rest: t.languages.jsx
      },
      alias: "language-javascript"
    }
  }, t.languages.jsx.tag);

  var e = function e(t) {
    return t ? "string" == typeof t ? t : "string" == typeof t.content ? t.content : t.content.map(e).join("") : "";
  },
      a = function a(n) {
    for (var s = [], g = 0; g < n.length; g++) {
      var o = n[g],
          i = !1;

      if ("string" != typeof o && ("tag" === o.type && o.content[0] && "tag" === o.content[0].type ? "</" === o.content[0].content[0].content ? s.length > 0 && s[s.length - 1].tagName === e(o.content[0].content[1]) && s.pop() : "/>" === o.content[o.content.length - 1].content || s.push({
        tagName: e(o.content[0].content[1]),
        openedBraces: 0
      }) : s.length > 0 && "punctuation" === o.type && "{" === o.content ? s[s.length - 1].openedBraces++ : s.length > 0 && s[s.length - 1].openedBraces > 0 && "punctuation" === o.type && "}" === o.content ? s[s.length - 1].openedBraces-- : i = !0), (i || "string" == typeof o) && s.length > 0 && 0 === s[s.length - 1].openedBraces) {
        var p = e(o);
        g < n.length - 1 && ("string" == typeof n[g + 1] || "plain-text" === n[g + 1].type) && (p += e(n[g + 1]), n.splice(g + 1, 1)), g > 0 && ("string" == typeof n[g - 1] || "plain-text" === n[g - 1].type) && (p = e(n[g - 1]) + p, n.splice(g - 1, 1), g--), n[g] = new t.Token("plain-text", p, null, p);
      }

      o.content && "string" != typeof o.content && a(o.content);
    }
  };

  t.hooks.add("after-tokenize", function (t) {
    ("jsx" === t.language || "tsx" === t.language) && a(t.tokens);
  });
}(Prism);